import React from "react";
import ProductTitle from "./ProductTitle";
import AUTORequestCard from "./AUTORequestCard";
import "./AUTOContainer.scss";

const AUTOContainer = ({ autoRequests }) => (
  <div className="mb-5">
    <ProductTitle icon="car" title="Demandes d'Assurance Auto" />
    <div className="mt-3">
      <p>
        Nous étudions vos demandes à partir des informations que vous avez
        renseignées. Nous revenons vers vous au plus vite.
      </p>
    </div>
    {autoRequests.map((request) => (
      <AUTORequestCard key={request.id} request={request} />
    ))}
  </div>
);

export default AUTOContainer;
